import {Translate} from "../Translate";

const adminRoutes = [
    {
        id: 'dashboard',
        title: Translate.dashboard,
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
    },
    {
        id: 'wallet',
        title: Translate.myWallet,
        type: 'item',
        icon: 'account_balance_wallet',
        url: '/wallet/view',
        feature: 'wallet'
    },
    {
        id: 'manage_pricing',
        title: Translate.managePricing,
        type: 'item',
        permission: 'manageShops',
        icon: 'price_change',
        url: '/manage/pricing/all',
        feature: 'marketplace'
    },
    {
        id: 'manageShops',
        title: Translate.manageShops,
        type: 'item',
        icon: 'shop',
        permission: 'manageShops',
        url: '/manage/shops',
        exact:true,
        feature: 'marketplace'
    },
    {
        id: 'manageProducts',
        title: Translate.manageProducts,
        type: 'collapse',
        icon: 'shopping_cart',
        permission: 'manageShops',
        children: [
            {
                id: 'manageProducts',
                title: Translate.productsList,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/products',
                exact:true
            },
            {
                id: 'manageCategories',
                title: Translate.manageCategories,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/categories',
                exact:true
            },
            {
                id: 'manageAttributes',
                title: Translate.manageAttributes,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/attributes',
                exact:true,
                feature: 'variable_products'
            },
            {
                id: 'manageRevisions',
                title: Translate.manageRevisions,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/revisions',
                exact:true
            },
        ],
    },
    {
        id: 'manageOrders',
        title: Translate.manageOrders,
        type: 'collapse',
        icon: 'receipt',
        permission: 'manageOrders',
        children: [
            {
                id: 'manageOrders',
                title: Translate.ordersList,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/orders',
                exact:true
            },{
                id: 'manageTransferPricing',
                title: Translate.manageTransferPricing,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/transfer-price',
                exact:true
            },
            {
                id: 'manageDiscounts',
                title: Translate.manageDiscounts,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/discounts',
                exact: true
            },
            {
                id: 'manageFestivals',
                title: Translate.manageFestivals,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/festivals',
                exact: true
            },
            {
                id: 'incomeSharing',
                title: Translate.incomeSharing,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/income-sharing',
                exact: true
            },
            {
                id: 'managePackagesOrders',
                title: Translate.managePackagesOrders,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/packages-orders',
                exact: true
            },

        ],
    },
    {
        id: 'settings',
        title: Translate.settings,
        type: 'group',
        permission: 'manageSettings',
    },
    {
        id: 'site_settings',
        title: Translate.siteSettings,
        type: 'collapse',
        icon: 'web',
        permission: 'manageSettings',
        children: [
            {
                id: 'siteInformation',
                title: Translate.siteInformation,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/information',
                exact:true
            },
            {
                id: 'manageContacts',
                title: Translate.contactInformation,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/contact',
                exact:true
            },
            /*{
                id: 'translateFront',
                title: Translate.translateFront,
                type: 'item',
                url: '/settings/translate-front',
                exact:true
            },*/
            {
                id: 'manageBanner',
                title: Translate.manageBanners,
                type: 'item',
                icon: "chevron_left",
                url: '/settings/banners',
                exact:true
            },
            {
                id: 'manageRents',
                title: Translate.manageRents,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/rents',
                exact:true,
            },
            {
                id: 'manageRedirects',
                title: Translate.manageRedirects,
                type: 'item',
                icon: "chevron_left",
                url: '/settings/redirects',
                exact:true,
                feature:"redirects"
            },
            {
                id: 'manageCommissions',
                title: Translate.manageCommissions,
                type: 'item',
                icon: "chevron_left",
                url: '/setting/commissions',
                exact:true
            },
            {
                id: 'managePackages',
                title: Translate.managePackages,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/packages',
                exact:true
            },

            {
                id: 'manageBrands',
                title: Translate.manageBrands,
                type: 'item',
                url: '/manage/brands',
                icon: "chevron_left",
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageWriters',
                title: Translate.manageWriters,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/writers',
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageTranslators',
                title: Translate.manageTranslators,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/translators',
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageNarrators',
                title: Translate.manageNarrators,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/narrators',
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageLabels',
                title: Translate.manageLabels,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/labels',
                exact:true,
                feature: 'brands'
            },
            {
                id: 'manageComments',
                title: Translate.manageReviews,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/reviews',
                exact:true
            },
            {
                id: 'manageFAQS',
                title: Translate.faqs,
                type: 'item',
                icon: "chevron_left",
                url: '/manage/faqs',
                exact:true
            },
        ],
    },
    {
        id: 'usersManagement',
        title: Translate.usersManagement,
        type: 'collapse',
        icon: 'group',
        permission: 'manageSettings',
        children: [
            {
                id: 'agents',
                title: Translate.agentsManagement,
                type: 'item',
                url: '/manage/agents',
                icon: "chevron_left",
                exact:true,
                feature:"agent"
            },
            {
                id: 'allUsers',
                title: Translate.allUsers,
                type: 'item',
                url: '/manage/users/view/all',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'marketers',
                title: Translate.marketersList,
                type: 'item',
                url: '/manage/users/view/marketer',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'usersActivity',
                title: Translate.usersActivity,
                type: 'item',
                url: '/manage/activities',
                exact:true,
                feature:"activity_log",
                icon: "chevron_left",
            },

        ],
    },
    {
        id: 'manageTickets',
        title: Translate.manageTickets,
        type: 'collapse',
        icon: 'chat',
        permission: 'manageSettings',
        feature:"tickets",
        children: [
            {
                id: 'manageDepartments',
                title: Translate.viewAllLists,
                type: 'item',
                url: '/manage/tickets',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'manageDepartments',
                title: Translate.referredToMe,
                type: 'item',
                url: '/tickets',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'bulkTicket',
                title: Translate.sendBulkTicket,
                type: 'item',
                url: '/manage/bulk-ticket',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'manageDepartments',
                title: Translate.manageDepartments,
                type: 'item',
                url: '/manage/departments',
                icon: "chevron_left",
                exact:true
            },

        ]
    },
    {
        id: 'managePages',
        title: Translate.managePages,
        type: 'item',
        icon: 'description',
        url: '/manage/pages',
        permission: 'manageSettings',
    },
    {
        id: 'manageContact',
        title: Translate.manageContact,
        type: 'item',
        url: '/manage/contacts',
        icon: 'contact_mail',
        permission: 'manageSettings',
        exact:true
    },
    {
        id: 'manageViolations',
        title: Translate.manageViolations,
        type: 'item',
        icon: "report",
        url: '/manage/violations',
        exact:true,
        feature:"product_error_report"
    },
    {
        id: 'paymentManagement',
        title: Translate.paymentManagement,
        type: 'collapse',
        icon: 'badge',
        permission: 'managePayments',
        feature:"wallet",
        children: [
            {
                id: 'manageVerifications',
                title: Translate.manageVerifications,
                type: 'item',
                url: '/manage/verifications',
                icon: "chevron_left",
                exact:true
            },
            {
                id: 'manageWallets',
                title: Translate.manageWallets,
                type: 'item',
                url: '/manage/wallets',
                icon: "chevron_left",
                exact:true,
            },
            {
                id: 'manageWalletsRequests',
                title: Translate.manageWalletsRequests,
                type: 'item',
                url: '/manage/wallets-requests',
                icon: "chevron_left",
                exact:true,
            },

        ],
    },

    {
        id: 'blog',
        title: Translate.blog,
        type: 'collapse',
        icon: 'article',
        feature:"blog",
        children: [
            {
                id: 'contents',
                title: Translate.contents,
                type: 'item',
                url: '/manage/contents',
                exact:true
            },
            {
                id: 'makeContent',
                title: Translate.makeContent,
                type: 'item',
                url: '/create/content',
                exact:true,
            },
            {
                id: 'blogCategories',
                title: Translate.manageBlogCategories,
                type: 'item',
                url: '/manage/blog-categories',
                exact:true,
            },
            {
                id: 'manageBlogComments',
                title: Translate.manageBlogComments,
                type: 'item',
                url: '/manage/blog-comments',
                feature:"blog_comments",
                exact:true,
            },
        ],
    },

    {
        id: 'fileManager',
        title: Translate.fileManager,
        type: 'item',
        icon: 'image',
        url: '/file-manager',
        roles: ['admin','support','supplier','product_manager'],
        permission: "fileManagerPage",
    },

];
export default adminRoutes;
